window.AddEmailForm = function (scope) {
    var self = this;
    var formName = "add-email-form";
    var _protected = BaseForm.call(self, formName, scope);


    self.save = function () {
        var defer = $q.defer();
        self.validator.validate(function (isValid) {
            if (isValid) {
                JobApplicationAPI.submitUserEmail(self.data.email)
                    .then(function (res) {
                        defer.resolve();
                    })
                    .catch(function (err) {
                        console.error('err', err);
                        defer.reject(err);
                    })
            }
        });

        return defer.promise;
    }

};
